import React, {
  lazy,
} from 'react';
import {
  RouteObject,
} from 'react-router-dom';
import LazyLoadComponent from 'core/components/LazyLoadComponent';

const chartsRoutes: RouteObject[] = [{
  path: '/charts/:id/:tab?',
  element: (
    <LazyLoadComponent
      Component={lazy(() => import('./pages/Details'))}
    />
  ),
}];

export default chartsRoutes;
